import { useQuery } from "@tanstack/react-query";
import { useAccess, useAccountId } from "../Auth/auth-functions";
import { api } from "./api";
import { AzureADRoles } from "../Auth/auth-roles";
import { ListPriorityDto } from "../models/priority.models";

export const useGetPrioritiesQuery = () => { 
	const hasAccess = useAccess(AzureADRoles.All);
	const accountId = useAccountId();

	return useQuery({
		queryKey: ['priorities', accountId],
		queryFn: async () => {
			let res = await api.get<ListPriorityDto[]>('/priorities');
			return res.data;
		},
		staleTime: 60 * 60 * 1000,
		gcTime: 60 * 60 * 1000,
		enabled: hasAccess
	});
}